export default function redirectToPage(page) {
  if (window) {
    const { protocol, host } = window.location;
    const url = `${protocol}//${host}/${page}`;
    window.location.assign(url);
  }
}
